import React, { useContext, useEffect, useState } from "react";
import { vehicleHeaderTable, mock } from "./utils";
import ModalContext from "../../../../contexts/ModalContext";
import {
    HeaderRow,
    HeaderCell,
    ItemRow,
    ItemCell,
    ImageCell,
    OptionsImage,
    Table
} from "./style"

import details from '../../../../assets/router/details.svg';
import edit from '../../../../assets/router/edit-pen.svg';
import trash from '../../../../assets/router/trash.svg';
import { VehicleContext } from "../../../../contexts/VehicleContext";
import axios from "axios";
import { VehicleInterface } from "../../../../components/routerModal/vehicleContent/vehicleForm";
import { set } from "date-fns";
import { useNavigate, useOutletContext } from "react-router-dom";
import { RouterOutletType } from "../index2";
import SectionContext from "../../../../contexts/SectionContext";
import { GlobalTable, HeaderLine, Td, TdButtons, Th, Tr } from "../../../../components/styles/table-style";
import { FeedbackContext } from "../../../../contexts/FeedbackContext";
import { EquipmentOutletType } from "../../Equipment";
interface vehicleTableType {
    onChange?: ()=> void
}

const VehicleTable: React.FC<vehicleTableType> = (props)=>{
const { setFeedback } = useContext(FeedbackContext)
const {setModalSection, setModalActive} = useContext(ModalContext)
const {setVehicle, vehicle} = useContext(VehicleContext)
const {setRouterSection} = useContext(SectionContext)
const navigate = useNavigate()
const [vehicles, setVehicles] = useState<VehicleInterface[] | null>(null)
    const handleViewModal = async (modal: string, id: number)=>{
        
        await getVehicle(id);
        // setModalSection(modal);
        // setModalActive(true);   
        navigate(`${id}`)
    }
    const handleEditModal = async (modal: string, id: number)=>{
        
        await getVehicle(id);
        // setModalSection(modal);
        // setModalActive(true);   
        navigate('create')
    }
    const { setTabIndex } = useOutletContext<EquipmentOutletType>()
    
  useEffect(() => {
    setTabIndex(0)
    setRouterSection('vehicle')
  }, [])
const vehicleModel:  VehicleInterface = {
    id: 1,
    plate: '121bb',
    model: "FIAT UNO",
    year: 2010,
    capacity: 1.234,
    size: 12,
    restriction: "Restricao"
}


const deleteVehicle = async (id: number)=>{
    try{
        const response = await axios.delete(`${process.env.REACT_APP_ROUTER_BASE_URL}/vehicle/${id}`);
        setFeedback({
            isOpen:true,
            message:'Veículo deletado!',
            statusOk:true
          })
    }catch{
        setFeedback({
            isOpen:true,
            message:'Erro ao deletar Veículo',
            statusOk:false
          })
    }
    
    
       
    
    getVehicles();
}
const getVehicle = async (id: number) => {
    const response = await axios.get(`${process.env.REACT_APP_ROUTER_BASE_URL}/vehicle/${id}`);
    setVehicle(response.data);
}
const getVehicles = async () => {
    const response = await axios.get(`${process.env.REACT_APP_ROUTER_BASE_URL}/vehicle`);
    setVehicles(response.data);
    console.log(response.data)
}
    useEffect(()=>{
        
        getVehicles();
    },[])
    return(
        <>
        <GlobalTable>
            <thead>
                <HeaderLine>
                    {vehicleHeaderTable.map((header)=>(
                        <Th key={header}>{header}</Th>
                    ))}
                    <Th></Th>
                </HeaderLine>
            </thead>

                    <tbody>

                    
                {vehicles?.map((veiculo, index)=>(
                    <Tr key={veiculo.plate}>
                        <Td key={veiculo.plate}>{veiculo.plate}</Td>
                        <Td key={veiculo.model}>{veiculo.model}</Td>
                        <Td key={veiculo.year}>{veiculo.year}</Td>
                        <Td key={veiculo.capacity}>{veiculo.capacity}kg {veiculo.size}m3</Td>
                        <Td key={veiculo.restriction}>{veiculo.restriction}</Td>
                        
                        <TdButtons>
                        <OptionsImage onClick={async ()=> await handleViewModal('routerVehicleDetail', veiculo.id)} src={details}alt='Icon to show vehicle'/>
                        <OptionsImage onClick={async ()=> await handleEditModal('routerVehicleForm', veiculo.id)} src={edit}alt='Icon to edit vehicle'/>
                        <OptionsImage onClick={async ()=> await deleteVehicle( veiculo.id)}src={trash}alt='Icon to delet vehicle'/>
                        </TdButtons>
                        
                    </Tr>
                ))}
            </tbody>
        </GlobalTable>
        </>
    )
}

export default VehicleTable;